import React from 'react'
import { Config } from '../layout/Providers'

// context object
export const ConfigContext = React.createContext<null | Config>(null)

// context provider props
export interface ConfigProviderProps {
  children: JSX.Element | JSX.Element[]
  config: Config
}

// context provider
const SiteMetadataProvider = ({ children, config }: ConfigProviderProps) => {
  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  )
}

export default SiteMetadataProvider
